<template>
    <div v-if="questions.length" class="accordion" id="questionAccordionInternal">
        <!--fixa template för loopen-->
        <template v-for="q, i in questions" :key="i">
            <div class="accordion-item">

                <strong class="accordion-header" :id="'heading' + q.id">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        :data-bs-target="'#collapse-' + q.id" aria-expanded="false" :aria-controls="'collapse-' + q.id"
                        v-html="q.title.rendered">
                    </button>
                </strong>
                <div :id="'collapse-' + q.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + q.id"
                    data-bs-parent="#questionAccordionInternal">
                    <div class="accordion-body">
                        <!-- Accordion for External Answer -->
                        <div class="accordion" :id="'subAccordionExternal-' + q.id">
                            <div class="accordion-item" v-if="q.content.rendered">
                                <span class="accordion-header" :id="'headingExternal-' + q.id">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        :data-bs-target="'#collapseExternal-' + q.id" aria-expanded="false"
                                        :aria-controls="'collapseExternal-' + q.id">
                                        Externt svar
                                    </button>
                                </span>
                                <div :id="'collapseExternal-' + q.id" class="accordion-collapse collapse"
                                    :aria-labelledby="'headingExternal-' + q.id"
                                    :data-bs-parent="'#subAccordionExternal-' + q.id">
                                    <div class="accordion-body">
                                        <div class="p-4 rounded bg-success-light">
                                            <span v-if="q.content.rendered.length > 0" v-html="q.content.rendered"></span>
                                            <span
                                                v-if="q.content.rendered.length < 1 && q.acf.call_to_action.length < 1">Inget
                                                externt svar hittades</span>
                                            <a v-if="q.acf.call_to_action.length != 0" class="btn btn-primary my-2"
                                                target="_blank" :href="q.acf.call_to_action_link">
                                                {{ q.acf.call_to_action }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Accordion for Internal Answer -->
                        <div class="accordion mt-3" :id="'subAccordionInternal-' + q.id">
                            <div class="accordion-item">
                                <span class="accordion-header" :id="'headingInternal-' + q.id">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        :data-bs-target="'#collapseInternal-' + q.id" aria-expanded="false"
                                        :aria-controls="'collapseInternal-' + q.id">
                                        Internt svar
                                    </button>
                                </span>
                                <div :id="'collapseInternal-' + q.id" class="accordion-collapse collapse"
                                    :aria-labelledby="'headingInternal-' + q.id"
                                    :data-bs-parent="'#subAccordionInternal-' + q.id">
                                    <div class="accordion-body">
                                        <div class="my-3 p-4 rounded bg-primary-light">
                                            <span v-if="q.acf.internal.length > 0" v-html="q.acf.internal"></span>
                                            <span v-else>Inget internt svar hittades</span>

                                            <div class="mt-2">
                                                <strong>Ansvarig: </strong><span v-for="(personal, j) in q.acf.contact"
                                                    :key="j">{{ j == q.acf.contact.length - 1 ? personal.post_title :
                                                        personal.post_title + ", " }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: { singleq: { type: String } },
    data() {
        let questions = [];
        let singleQ = this.singleq.split(',')



        return {
            questions,
            singleQ
        }


    },

    methods: {

        fetchQuestions(q) {
            fetch("https://cockpit.gavleenergi.se/wp-json/wp/v2/faq?include=" + q)
                .then(res => res.json())
                .then(json => { this.questions = json })








        }
    },
   async mounted() {

await        this.fetchQuestions(this.singleQ)
console.log(this.questions)
    }
}


</script>
